import React from 'react';

function Summary({ withImage, path_story }) {
  if (!path_story) return null;

  const renderImages = () => {
    return (
      <div className="flex overflow-x-auto mt-4 mb-4 ml-4 mr-4">
        {Array.from({ length: 5 }, (_, index) => (
          <img
            key={index}
            src={`${path_story.image_path}${index}.png`}
            alt={`Detail of scene ${index}`}
            className="w-48 h-auto mx-2" // 各画像に左右のマージンを追加
          />
        ))}
      </div>
    );
  };

  return (
    <div className={`bg-white border border-gray-300 ${withImage ? 'w-auto' : 'w-3/4'} mx-auto`}>
      <h3 className='mb-3 text-lg font-semibold text-center hover:bg-gray-100 m-2'>Summary</h3>
      {withImage ? renderImages() : (
        <div className="max-w-4xl mx-auto">  {/* Adjusted max-width from max-w-xl to max-w-4xl */}
          <p className='mb-4'>{path_story.summary}</p>
        </div>
      )}
    </div>
  );
}

export default Summary;
